import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as FleetCoachBulkUploadActions from "../../store/actions/FleetCoachBulkUpload";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const FleetCoachBulkUploadDashboard = ({ getBulkUploadUrl }) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="FleetCoachBulkUploadBtn"
      uploadUrl="/catalyst/fleet-coach/bulk-update"
      sampleURL="/sample/bulk_upload_driver_fc_mapping.csv"
      id="FleetCoachBulkUploadModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Bulk Upload Driver FC Mapping"
      getUploadUrl={getBulkUploadUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(
      FleetCoachBulkUploadActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(FleetCoachBulkUploadDashboard);
